module.exports = __webpack_public_path__ + "static/media/vegitables_45.e517d96a.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/vegitables/vegitables_45.csv
// module id = 630
// module chunks = 0